/* Lambda Water — navigation, product media, and variant selection. */
(function () {
  'use strict';

  function menuParts() {
    return { toggle: document.querySelector('.nav-toggle'), nav: document.querySelector('.mobile-nav') };
  }

  function setMenu(open, restoreFocus) {
    const parts = menuParts();
    if (!parts.toggle || !parts.nav) return;
    if (!parts.nav.id) parts.nav.id = 'mobile-navigation';
    parts.toggle.setAttribute('aria-controls', parts.nav.id);
    parts.toggle.setAttribute('aria-expanded', String(open));
    parts.toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    parts.nav.classList.toggle('open', open);
    parts.toggle.classList.toggle('open', open);
    if (open) parts.nav.removeAttribute('inert');
    else parts.nav.setAttribute('inert', '');
    if (!open && restoreFocus) parts.toggle.focus();
  }

  function setImage(image, source, alt, width, height) {
    if (!image || !source) return;
    image.src = source;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    if (alt != null) image.alt = alt;
    if (width && height) {
      image.width = Number(width);
      image.height = Number(height);
    }
  }

  function selectVariant(select, updateURL) {
    const option = select.selectedOptions[0];
    const product = select.closest('.product-page') || select.closest('[data-product-section]');
    if (!option || !product) return;
    const available = option.dataset.available !== 'false' && !option.disabled;
    const price = product.querySelector('.product-price');
    const compare = product.querySelector('.product-compare-price');
    const availability = product.querySelector('.product-availability');
    const sku = product.querySelector('[data-product-sku]');
    const skuWrap = product.querySelector('.product-sku');
    const button = select.form && select.form.querySelector('.atc-btn');
    if (price && option.dataset.priceFormatted) price.innerHTML = option.dataset.priceFormatted;
    if (compare) {
      const show = Number(option.dataset.compareAtPrice || 0) > Number(option.dataset.price || 0);
      compare.hidden = !show;
      compare.innerHTML = option.dataset.compareAtFormatted || '';
    }
    if (availability) {
      availability.textContent = available ? 'In stock' : 'Sold out';
      availability.dataset.available = String(available);
    }
    if (sku) sku.textContent = option.dataset.sku || '';
    if (skuWrap) skuWrap.hidden = !option.dataset.sku;
    if (button) {
      button.dataset.price = option.dataset.price || '';
      button.disabled = !available || select.form.dataset.cartSubmitting === 'true';
      if (select.form.dataset.cartSubmitting !== 'true') button.textContent = available ? 'Add to cart' : 'Sold out';
    }
    if (option.dataset.image) {
      const main = product.querySelector('.gallery-main img');
      setImage(main, option.dataset.image, option.dataset.imageAlt, option.dataset.imageWidth, option.dataset.imageHeight);
      product.querySelectorAll('.gallery-thumb').forEach(function (thumb) {
        const selected = thumb.dataset.src === option.dataset.image;
        thumb.classList.toggle('active', selected);
        thumb.setAttribute('aria-pressed', String(selected));
      });
    }
    if (updateURL) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url.toString());
    }
  }

  function initialize(context) {
    setMenu(false, false);
    const subject = (context || document).querySelector('[data-contact-subject]');
    if (subject && !subject.value.trim() && new URLSearchParams(window.location.search).get('subject') === 'wholesale') {
      subject.value = 'Wholesale / bulk order';
    }
    (context || document).querySelectorAll('.product-variant-select, .product-page select[name="id"]').forEach(function (select) {
      selectVariant(select, false);
    });
  }

  document.addEventListener('click', function (event) {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    if (!target) return;
    if (target.closest('.nav-toggle')) {
      const parts = menuParts();
      setMenu(parts.toggle.getAttribute('aria-expanded') !== 'true', false);
      return;
    }
    const parts = menuParts();
    if (parts.nav && parts.nav.classList.contains('open')) {
      if (target.closest('.mobile-nav a') || !target.closest('.site-header')) setMenu(false, false);
    }
    const thumb = target.closest('.gallery-thumb');
    if (thumb) {
      const gallery = thumb.closest('.product-gallery') || thumb.closest('.product-page');
      if (!gallery) return;
      gallery.querySelectorAll('.gallery-thumb').forEach(function (button) {
        const selected = button === thumb;
        button.classList.toggle('active', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      setImage(gallery.querySelector('.gallery-main img'), thumb.dataset.src, thumb.dataset.alt, thumb.dataset.width, thumb.dataset.height);
      return;
    }
    const quantityButton = target.closest('.qty-minus, .qty-plus, .quantity-wrap .qty-btn');
    if (!quantityButton) return;
    const input = quantityButton.parentElement.querySelector('.qty-input, input[name="quantity"]');
    if (!input) return;
    const step = Number(input.step) || 1;
    const minimum = input.min === '' ? 1 : Number(input.min);
    const maximum = input.max === '' ? Infinity : Number(input.max);
    const decrease = quantityButton.classList.contains('qty-minus') || quantityButton.dataset.action === 'minus';
    const current = Number(input.value) || minimum;
    input.value = Math.max(minimum, Math.min(maximum, current + (decrease ? -step : step)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('.product-variant-select, .product-page select[name="id"]')) selectVariant(event.target, true);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    const parts = menuParts();
    if (parts.nav && parts.nav.classList.contains('open')) setMenu(false, true);
  });

  const desktop = window.matchMedia('(min-width: 921px)');
  if (desktop.addEventListener) desktop.addEventListener('change', function () { setMenu(false, false); });
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  else initialize(document);
}());
